import differenceBy from 'lodash/differenceBy';
import {
  RAFFLE_SERIAL_DATA_REQUEST,
  RAFFLE_SERIAL_DATA_SUCCESS,
  RAFFLE_SERIAL_DATA_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RAFFLE_SERIAL_DATA_REQUEST:
      return { ...state, isLoading: true, error: null };
    case RAFFLE_SERIAL_DATA_SUCCESS: {

      const { serialType = null, selectedTickets, full } = action.payload;
      
      // Gelen seri bilet dataları.
      let ticketsFull = full.serialTickets || [];

      // Seçilen tab'a göre seçili biletler ayrıştırılır.
      const sameSelectedTicketsFull = selectedTickets.filter(ticketItem => ticketItem.ticketType === 'FULL' && ticketItem.serialType === serialType);

      // Gelen datanın içerisinde daha önce seçilmişlerden varsa, onları siliyoruz.
      const removeSelectedsFull = differenceBy(ticketsFull, sameSelectedTicketsFull, 'serialCode');

      // Yukarıdaki silme işine istinaden gelen datadan çıkarılacak bilet sayısını hesaplıyoruz.
      const trimSizeFull = sameSelectedTicketsFull.length - (ticketsFull.length - removeSelectedsFull.length);

      // Gelen datadan seçilen bilet kadar data atılır.
      const trimmedTicketsFull = trimSizeFull > 0 ? removeSelectedsFull.slice(0, -trimSizeFull) : removeSelectedsFull;

      // Gelen datanın baş kısmına seçilen biletler eklenir.
      const updatedTicketsFull = sameSelectedTicketsFull.length > 0 ? [...sameSelectedTicketsFull, ...trimmedTicketsFull] : trimmedTicketsFull;
      
      // Ek field'lar eklenir. Bu field'lar lottery slip için gereklidir.
      let enrichedTicketsFull = updatedTicketsFull.map(ticketItem => ({ ...ticketItem, ticketPrice: full.ticketPrice, serialType: serialType }));

      // Güncellenmiş reducer datamızı oluşturuyoruz.
      const updatedPayload = {
        ...action.payload,
        full: {
          ...action.payload.full,
          serialTickets: enrichedTicketsFull
        },
      };

      return {
        data: {
          ...updatedPayload
        }, isLoading: false, error: null };
    }
      
    case RAFFLE_SERIAL_DATA_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
